// Utils
import { currencyFormatter } from "../../utils/Utils";

// MUI imports
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export const SelectStaffOrderTotal = ({ order }) => {
  return (
    <Paper
      elevation={2}
      sx={{ p: 2, display: "flex", flexDirection: "row-reverse" }}
    >
      <Typography sx={{ fontWeight: "bold", pl: 2 }}>
        Total: {currencyFormatter("GB", order.orderTotal)}
      </Typography>
    </Paper>
  );
};
